import React from "react";

import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import  NuDropdown from "components/nubox/NuDropdown";


import NuConfirm from "components/nubox/Box/NuConfirm";
import BoxBuscarDoc from 'views/_box/BoxBuscarDoc';

import { withRouterJim } from "router/withRouterJim";



import user from 'assets/img/user.jpg';

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const initialForm={
 
  id_doc: 0,  //pero de docente
  nomape_tmp:'',
  id_peri:0,
  periodo:'',
}

/*$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$*/
class RepMateXDoc extends React.Component {  

  modalRef = React.createRef();//create ref
  
  state = {
    modalOpen: false,  /*dialogo */
    form: Object.assign({}, initialForm),
    data: [],/* lista  */
    carreras:[], //para combo
    
  };
  
  //------------------------------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({data:[]});

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');
  
    //this.setState({fechai: defaultValue}); 
    this.setState({ form:{...this.state.form, fecha: defaultValue,}}); 

    //this.cargar_globalx();
    //const user = this.props.store.user
    let id_peri = this.props.store.user.id_peri;
    let periodo = this.props.store.user.periodo;

    this.setState({ form:{...this.state.form, 
                            fecha: defaultValue,
                            id_peri: id_peri,
                            periodo: periodo,
                            }}); 
    //this.cargar_carreras();
    //this.fetchData(this.state.fechai);
    console.log(this.modalRef);
  }

  //------------ cambiamos la fecha
  /*handleChange = event =>{
    this.setState({ name: event.target.value});
  }*/
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name="?" en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };
  
  
  //====================================================== 
  //----cargamos los datos desde la base de datos
  /*{
    "id_medico": 1,
        "nombre": "Dr. Gerson Abner Villafuerte Oporto",
        "dir": "",
        "tel": "",
        "cel": "",
        "foto_path1": ""
        "especialidad": "Ortodoncia"
  },*/
  //----cargamos combo
  /*cargar_carreras = async() => {
    let param = { }

    await axios2.post('cbo_carrera', param).then(res => {
        if(res.data.length>0){ 
            this.setState({carreras: res.data});
            this.setState({form:{...this.state.form, id_carre: res.data[0].value}});
        }else{
          toast.error('No existen datos');
        }
    }).catch(error => {
        alert('---- Existio un error ---');
        console.log(error);
    });
  };*/
  //--------------------------------------------------
 //------------------ BOX ----------------------------
 //{id_doc: 127, nomape_tmp: 'BARRAL OYOLA, MIJAEL'}
  toggle = () =>{ this.setState({modalOpen: !this.state.modalOpen})}

  handleClickBoxDoc=(item)=>{
    //alert ("click" );
    //---lo ocultamos
    this.toggle();
    //---------
    //---------grabamos la materia a la programacion del estudiante
    console.log(item);
    //this.saveNew( item );
    //ahora asignamos los valores
    //this.setState({ materia_selected: item });
    this.setState({form:{...this.state.form, 
                        id_doc: item.id_doc,
                        nomape_tmp: item.nomape_tmp }});
  }
  buscar_click =(e)=>{
    e.preventDefault()
    this.toggle();
  }
  //-----------------------------------------------
  
  /************************************************ */
  //-----------------------------------  
  imprimir =()=>{
    let param =  this.state.form;
    //param.idd =1;
    //param.ope ='e';
    let id_doc = this.state.form.id_doc;
    let id_peri = this.state.form.id_peri;
    console.log(param);
    //------------ validacion --------

    let fileURL = process.env.REACT_APP_API_URL  + "rep_mate_x_doc_pdf/"+ id_doc+"/"+id_peri;
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
  }
  //----------------
  //-------------------------------------
  render() {
    
    return (
      <div>
        <ToastContainer />
        <div className="content">

        <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                {/*<!-- -->*/}
                <div className="pull-left">
                    <h3>Reporte de materias por carrera</h3>
                </div>
                {/*<!-- -->*/}
                
            </div>
        </div>
        {/*<!--- ------------------------------->*/}
        <div className="row d-flex justify-content-center">
          <div className=" card " style={{width: 400, padding: 0 }}>
            <div className="card-body">
              <form >

                  <table className="tabla_basic">
                    <tbody>
                      <tr>
                        <td><b>Docente:</b></td>
                        <td>
                          { this.state.form.nomape_tmp }
                        </td>

                        <td>
                          <button className="btn btn-sm btn-default" onClick={(e)=> this.buscar_click(e)} >
                            <i className="fa fa-plus"></i> Buscar
                          </button>
                        </td>
                      </tr>
                      {/*<!-- -->*/}
                     
                      <tr>
                        <td><b>Periodo:</b></td>
                        <td >
                          <span>{ this.state.form.periodo} </span>
                        </td>
                        <td></td>
                      </tr>
                      
                      <tr>
                        <td colspan="3"><div id="divres1"></div></td>
                      </tr>
                    </tbody></table>


              </form>

            </div>

            <div className="card-footer text-center">
              <Button onClick={ this.imprimir } className="btn btn-success">
                <i className="fa fa-binoculars" aria-hidden="true"></i>
                Export PDF
              </Button>
            </div>
          </div>

        </div>



          {/*<!-- -------------------------------------------------->*/}

        </div>

          <BoxBuscarDoc
            modalOpen={this.state.modalOpen}
            toggle={this.toggle}
            hancleClick={this.handleClickBoxDoc}
          />
      </div>
    );
  }
}
  
export default withRouterJim(RepMateXDoc);